import { createContext, useContext } from 'react';

import { THEME_MODES } from '@didaskill/domain/configurations/constants';

type ThemeContextType = {
  theme: THEME_MODES;
  setTheme: (theme: THEME_MODES) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  theme: THEME_MODES.DEFAULT,
  setTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);
